// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
	production: false,
	firebase: {
    apiKey: "AIzaSyAZ4km6pe_n24Q5QyIMVLk-3IxWz355TK0",
    authDomain: "admin-gravity.firebaseapp.com",
    databaseURL: "https://gravity-coliving-default-rtdb.europe-west1.firebasedatabase.app",
    projectId: "admin-gravity",
    storageBucket: "gravity-coliving.appspot.com",
    messagingSenderId: "1063208606913",
    appId: "1:1063208606913:web:e536db47ea157b19a18840",
    measurementId: "G-P2X0BL6096"  
	}
}

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
